import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/UI/Button/Button';
import { useNewCard } from '@/components/Profile/Cards/useNewCard';

export const AddCardButton = () => {
  const { t } = useTranslation();
  const { addCardHandler } = useNewCard();

  return (
    <Button appearance="secondary" isFullWidth onClick={addCardHandler}>
      {t('pages.cabinet.add_new_card')}
    </Button>
  );
};
